import { Component, OnInit, Input, ViewChild } from '@angular/core';
import { DetailCdaComponent } from './../detail-cda/detail-cda.component';

@Component({
  selector: 'app-talent-management',
  templateUrl: './talent-management.component.html',
  styleUrls: ['./talent-management.component.scss']
})
export class TalentManagementComponent implements OnInit {

  @ViewChild(DetailCdaComponent) detail: DetailCdaComponent;

  @Input() commonDataApi: any;
  categoryType: any;

  categories: any;

  constructor() { }

  async ngOnInit() {

    this.commonDataApi = this.commonDataApi[0]['accounts'][0]['categories'];
    for (let i = 0 ; i < this.commonDataApi.length ; i++) {
      if (this.commonDataApi[i]['category'] === 'Talent Management') {
        this.categoryType = this.commonDataApi[i]['category'];
        this.categories = this.commonDataApi[i]['entities'];
      }
    }
  }
}
